<template>
  <div>
    <el-select
      v-model="value1"
      placeholder="请选择"
      @change="onOptionsyear"
      id="inputselect"
      style="width: 200px; margin: 20px 20px 10px 15px"
    >
      <el-option
        v-for="item in optionsyear"
        :key="item.Id"
        :label="item.Name"
        :value="item.Id"
      >
      </el-option>
    </el-select>
    <!-- 2 -->
    <el-select
      v-model="value2"
      placeholder="请选择"
      @change="onOptionsyear"
      id="inputselect"
      style="width: 200px; margin: 20px 20px 10px 15px"
    >
      <el-option
        v-for="item in optionsyear2"
        :key="item.Id"
        :label="item.Name"
        :value="item.Id"
      >
      </el-option>
    </el-select>
    <!-- 3 -->
    <el-select
      v-model="value3"
      placeholder="请选择"
      @change="onClickClass"
      id="inputselect"
      style="width: 200px; margin: 20px 20px 10px 15px"
    >
      <el-option
        v-for="item in optionsyear3"
        :key="item.Id"
        :label="item.Name"
        :value="item.Id"
      >
      </el-option>
    </el-select>

    <!-- <el-tabs v-model="activeName" type="card" @tab-click="handleClick" style="    margin-left: 15px;">
      <el-tab-pane
        :label="item.Name"
        :name="item.Id + ''"
        v-for="item in navBar"
        :key="item.Id"
      >     
      </el-tab-pane>
    </el-tabs> -->
    <el-row class="top_border">
      <button
        class="btn"
        v-for="(item, index) in navBar"
        @click="handleClick(index, item)"
        :class="cateIdIndex == index ? 'bgc_study' : ''"
        :key="index"
      >
        {{ item.Name }}
      </button>
    </el-row>
    <div>
      <div class="class_header">
        <chart
          v-if="isOpne"
          ref="chart1"
          :options="optionschart"
          :auto-resize="true"
          class="echarts_demo"
          style="height: 600px; width: 40%"
        ></chart>
        <div v-if="!isOpne" style="margin-top: 100px">
          <img src="../../assets/ZWT.png" alt="" />
        </div>
      </div>
      <el-table
        v-if="isOpne"
        :data="tableData"
        highlight-current-row
        style="
          margin: 0px auto 0px 15px;
          width: 1581px;
          border: 1px #eaeaea solid;
        "
        :header-cell-style="{
          background: '#FFEBDD',
          color: '#333333',
          textAlign: 'center',
          height: '50px',
        }"
        empty-text="暂无数据"
        :row-style="{ height: '60px' }"
        :cell-style="{ padding: '15px 0 15px 0px' }"
      >
        <el-table-column type="index" width="80" label=" " align="center">
        </el-table-column>
        <el-table-column
          prop="StudentName"
          label="姓名"
          width=""
          sortable
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="ClassName"
          label="班级"
          width=""
          sortable
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="Sex"
          label="性别"
          width=""
          sortable
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="Status"
          label="状态"
          width=""
          sortable
          align="center"
        >
        </el-table-column>
      </el-table>
      <!--工具条-->
      <el-col :span="24" class="toolbar" v-if="isOpne">
        <!-- <el-button
        style="margin-top: 20px"
        type="danger"
        @click="batchRemove"
        :disabled="this.sels.length === 0"
        >批量删除</el-button
      > -->
        <el-pagination
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :page-size="5"
          :total="total"
          style="text-align: center; margin-top: 30px"
          background
        ></el-pagination>
      </el-col>
    </div>
  </div>
</template>

<script>
import {
  GetCateSelectByType,
  GetYearsInfo,
  GetGradeInfo,
  GetClassInfo,
  GetPsychMeasureByCateId,
  AddRecordInfo,
} from "../../api/api";
import Charts from "../Form/Charts.vue";
export default {
  components: { Charts },
  data() {
    return {
      isOpne: false,
      cateIdIndex: 0,
      activeName: "1",
      orgOptions: {},
      optionschart: {},
      optionsyear: [],
      optionsyear2: [],
      optionsyear3: [],
      value1: "",
      value2: "",
      value3: "",
      navBar: [],
      categoryId: 0,
      tableData: [],
      total: 0,
    };
  },
  created() {
    this.GetCateSelectByType();
  },
  methods: {
    async AddRecordInfo(action, description) {
      var user = JSON.parse(
        window.localStorage.user ? window.localStorage.user : null
      );
      let res = await AddRecordInfo({
        userName: user.uRealName + "-" + user.uLoginName,
        action: action,
        description: description,
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.onClickClass();
    },
    // 第一个
    onOptionsyear() {
      if (this.value1 != "" && this.value2 != "") {
        let params = {
          studyYearId: this.value1,
          gradeId: this.value2,
        };
        GetClassInfo(params).then((res) => {
          if (res.data.response.length > 0) {
            this.value3 = res.data.response[0].Id;
            this.optionsyear3 = res.data.response;
            this.onClickClass(this.categoryId);
          } else {
            this.optionsyear3 = [];
            this.tableData = [];
            this.isOpne = false;
            this.value3 = null;
          }
        });
      } else {
        console.log(3333);
      }
    },
    // 班级事件
    onClickClass(categoryId) {
      console.log("班级");
      if (this.value3 == null) {
        return;
      }
      let params = {
        Type: 3,
        ClassId: this.value3,
        CategoryId: this.categoryId,
        StudyYearId: this.value1,
        GradeId: this.value2,
      };
      console.log(params);
      GetPsychMeasureByCateId(params).then((res) => {
        this.tableData = res.data.response.TableDetails;
        if (
          res.data.response.ChartData != null &&
          res.data.response.ChartData.Categories.length != 0
        ) {
          this.isOpne = true;
          let arr = res.data.response.ChartData.Categories;
          let Series = res.data.response.ChartData.Series;
          this.$nextTick(() => {
            this.optionschart = {
              color: ["#3398DB"],
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  // 坐标轴指示器，坐标轴触发有效
                  type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                },
              },
              grid: {
                left: "3%",
                right: "4%",
                bottom: "3%",
                containLabel: true,
              },

              xAxis: [
                {
                  type: "category",
                  data: res.data.response.ChartData.Categories,
                  axisTick: {
                    alignWithLabel: true,
                  },
                  axisLabel: {
                    interval: 0,
                    rotate: 60,
                  },
                },
              ],
              yAxis: [
                {
                  type: "value",
                },
              ],
              series: [
                {
                  name: "直接访问",
                  type: "bar",
                  barWidth:
                    res.data.response.ChartData.Categories.length < 2
                      ? "5%"
                      : "20%",
                  data: Series[0].Data,
                  itemStyle: {
                    normal: {
                      label: {
                        show: true, //开启显示
                        position: "top", //在上方显示
                        textStyle: {
                          //数值样式
                          color: "black",
                          fontSize: 16,
                        },
                      },
                    },
                  },
                },
              ],
            };
          });
        } else {
          this.isOpne = false;
        }
      });
    },
    // 获取分类
    GetCateSelectByType() {
      GetCateSelectByType({ id: 3 }).then((res) => {
        this.navBar = res.data.response;
        this.categoryId = this.navBar[0].Id;
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
      this.cateIdIndex = tab;
      this.categoryId = Number(event.Id);

      this.onClickClass(event.Id);
    },
    //获取用户列表
    GetYearsInfo() {
      GetYearsInfo().then((res) => {
        this.AddRecordInfo("查询", "评测管理-评测管理-查看心理测量测试结果");

        if (res.data.response.length > 0) {
          this.value1 = res.data.response[0].Id;
          this.optionsyear = res.data.response;
          GetGradeInfo().then((res) => {
            if (res.data.response.length > 0) {
              this.value2 = res.data.response[0].Id;
              this.optionsyear2 = res.data.response;
              this.onOptionsyear();
            } else {
              this.optionsyear2 = [];
              this.value2 = null;
            }
          });
        } else {
          this.optionsyear = [];
          this.value1 = null;
        }
      });
    },
  },
  mounted() {
    this.GetYearsInfo();
  },
};
</script>
<style scoped>
.top_border {
  margin-left: 5px;
}
.btn {
  /* min-width: 100px;
  height: 30px;
  border: 1px solid #999999; */
  background: #ffffff;
  border-radius: 23px;
  margin-left: 20px;
  font-size: 14px;
  line-height: 28px;
  margin: 10px;
  cursor: pointer;
  width: 105px;
  height: 30px;
  border-radius: 3px;
  border: 1px solid #cdcdcd;
}
.class_header {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.sex_header {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.bgc_study {
  /* //background: #4cbff4; */
  /* border: none; */
  color: #007aff;
  /* border: 1px solid #4cbff4; */
}
.chart_box {
  width: 95%;
  height: 300px;
  margin: 0 auto;
}
</style>